import { render } from "./ValentinesTheme.vue?vue&type=template&id=1ed5ddbb&scoped=true"
import script from "./ValentinesTheme.vue?vue&type=script&lang=js"
export * from "./ValentinesTheme.vue?vue&type=script&lang=js"

import "./ValentinesTheme.vue?vue&type=style&index=0&id=1ed5ddbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed5ddbb"]])

export default __exports__